<script setup>
import { useI18n } from 'vue-i18n';
import { formatTime } from '@chatwoot/utils';
import Avatar from 'next/avatar/Avatar.vue';
import Icon from 'next/icon/Icon.vue';
import LiveCard from './LiveCard.vue';

defineProps({
  title: { type: String, required: true },
  conversations: { type: Array, required: true },
  now: { type: Number, required: true },
  labelColors: { type: Object, default: () => ({}) },
  agent: { type: Object, default: null },
  stats: { type: Object, default: undefined },
});

const { t } = useI18n();

const renderTime = value => (value ? formatTime(value) : '–');
</script>

<template>
  <section
    class="flex flex-col min-h-48 max-h-[calc(100vh-14rem)] rounded-xl outline outline-1 -outline-offset-1 outline-n-weak bg-n-solid-1"
  >
    <header
      class="flex items-center gap-2 px-3 py-2.5 border-b border-n-weak shrink-0"
    >
      <Avatar
        v-if="agent"
        :name="agent.name"
        :src="agent.thumbnail"
        :size="28"
        :status="agent.availability_status"
        rounded-full
      />
      <Icon v-else icon="i-lucide-inbox" class="size-5 text-n-slate-11" />
      <h2 class="flex-1 min-w-0 text-sm font-medium truncate text-n-slate-12">
        {{ title }}
      </h2>
      <template v-if="agent">
        <span
          v-tooltip="t('LIVE_VIEW.TME_TOOLTIP')"
          class="text-xs tabular-nums text-n-slate-11"
        >
          {{ t('LIVE_VIEW.TME') }} {{ renderTime(stats?.tme) }}
        </span>
        <span
          v-tooltip="t('LIVE_VIEW.TMA_TOOLTIP')"
          class="text-xs tabular-nums text-n-slate-11"
        >
          {{ t('LIVE_VIEW.TMA') }} {{ renderTime(stats?.tma) }}
        </span>
      </template>
      <span
        class="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full tabular-nums bg-n-alpha-2 text-n-slate-11"
      >
        <Icon icon="i-lucide-messages-square" class="size-3" />
        {{ conversations.length }}
      </span>
    </header>

    <div
      v-if="conversations.length"
      class="flex flex-col gap-2 p-2 overflow-y-auto"
    >
      <LiveCard
        v-for="conversation in conversations"
        :key="conversation.id"
        :conversation="conversation"
        :now="now"
        :label-colors="labelColors"
      />
    </div>
    <p
      v-else
      class="flex items-center justify-center flex-1 p-6 text-sm text-center text-n-slate-10"
    >
      {{ t('LIVE_VIEW.EMPTY_COLUMN') }}
    </p>
  </section>
</template>
